export default {
	accepted: 'Aceptado',
	pending: 'Pendiente',
	rejected: 'Rechazado',
	'add-purchase': 'Añadir oferta',
	'edit-purchase': 'Editar oferta',
	'preview-purchase': 'Oferta de vista previa',
	'alert-message': 'Esta operación también eliminará tanto la entrada de recepción relacionada como el diario de material.',
	waiting: 'Esperando',
	'purchase-status': 'Estatus de oferta',

	'administration-acceptance': 'Aceptación de la administración',
	'farmer-acceptance': 'Aceptación de los agricultores',
	'administration-price': 'Precio de administración',
}